import React from "react";
import { autoFontColor } from "../../../utils/color";

/** The system's colored work-code pill: the code inside a chip filled with the
 *  work code's color, with contrast-aware text. `className` carries each call
 *  site's sizing/layout (the pill renders in legends, the publish rail, the
 *  per-code editor, and the bar popover). */
const CodePill: React.FC<{
  code: string | null;
  color: string | null;
  className?: string;
}> = ({ code, color, className }) => {
  const bg = color || "#666";
  return (
    <span className={className} style={{ backgroundColor: bg, color: autoFontColor(bg) }}>
      {code || "?"}
    </span>
  );
};

export default CodePill;
